import { PocModalDialog } from 'commons/components/components-wrapper';
import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const ModalDialogLayout = styled(PocModalDialog)`
    position: fixed;
    inset: 0;

    &.hidden {
        visibility: hidden;
    }

    &:not([hydrated]) {
        visibility: hidden;
    }

    owc-card {
        max-height: 90vh;
    }

    /* OWC-OVERRIDE: widen the dialog for side-by-side form layouts. owc-modal-dialog caps its
       focus-trap element and exposes only preset sizes (no max-width prop) in v7.6.0;
       !important beats owc's own max-width. Revisit on the next @one upgrade. */
    &.horizontal-form .owc-modal-dialog__backdrop-element__focus-trap-element {
        max-width: 960px !important;
    }

    &.horizontal-form owc-card {
        width: 100% !important;
        max-width: 960px;
    }

    .no-results {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: center;
        text-align: center;

        > owc-icon {
            font-size: 72px;
        }
    }

    owc-component-header[slot='header'] {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        min-width: 0;
        max-width: inherit;

        /* OWC-OVERRIDE: let the title container shrink so long titles ellipsize instead of
           pushing the close button out. owc-component-header's prefix containers have an
           implicit min-width: auto in v7.6.0 and no truncation prop. */
        [class*='owc-component-header__prefix-container'] {
            min-width: 0;
        }

        /* OWC-OVERRIDE: v6-parity divider colour; the border comes from the native separator
           prop but its colour is not configurable in v7.6.0. */
        &.owc-component-header--separator {
            border-bottom-color: ${owcTheme['one-color-gray-100']};
        }
    }

    owc-component-footer[slot='footer'] {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        /* OWC-OVERRIDE: v6-parity divider colour; the border comes from the native separator
           prop but its colour is not configurable in v7.6.0. */
        &.owc-component-footer--separator {
            border-top-color: ${owcTheme['one-color-gray-100']};
        }

        div[slot='suffix'] {
            display: flex;
            gap: 24px;
        }
    }

    div.modal-dialog-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 16px;

        > owc-progress-spinner {
            display: flex;
            justify-content: center;
            width: 100%;
            height: 100%;
            padding: 24px;

            svg {
                max-width: 50px;
            }
        }
    }

    .loading {
        pointer-events: none;
        opacity: 0.5;
    }
`;
